
<RouterView v-if="loaded" />
